import OptionMenu from "./option-menu.vue";
import OptionMenuItem from "./option-menu-item.vue";

export default {
  install(Vue) {
    Vue.component(OptionMenu.name, OptionMenu);
    Vue.component(OptionMenuItem.name, OptionMenuItem);
  }
}